import {object, pick} from "dot-object"

class ConfigItem {
  constructor(data) {

    this.id = data.id

    this.value = this.parseVal(data.value)
  }

  parseVal(value) {
    // ici on essaie de parser les arrays
    if(value === null) return null

    if(value.includes(";")) {
      return value.split(";")
      .map(val => val.trim())
      .filter(val => val.length > 0)
      .map(val => this.parseVal(val))
    }

    // ici on essaie de voir si c'est un nombre ou pas
    if(!isNaN(value)) return parseFloat(value)

    return value
  }

}


export class Config {

  all = {}

  init(json) {
    // 1 on crée un objet avec les ids
    let obj = {}

    json.forEach(item => {
        if(item.id) {
          obj[item.id] = item.value
        }
    })

    // 2 on le dot-obj

    this.all = object(obj)
    console.log("this.all", this.all)
  }

  get ids() { return this.all.map(c => c.id) }
  get(id, def = null) {
    let item = pick(id, this.all)

    if(item){
      return item
    }
    return def
  }



}


export default new Config()